import { SvgIcon } from "@material-ui/core";
export const greenRoad = (props) => {
  return (
    <SvgIcon {...props}>
      <svg width="24" height="24" version="1.1" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <g>
          <path d="m.412 21.2 6.88.0715 3.5-20.9h-1.89z" strokeWidth=".0396" />
          <path d="m21.6 21.5-6.99.0722-3.56-21.2h1.92z" strokeWidth=".0401" />
          <path d="m.412 21.1-.0541-20.9 8.43.143z" strokeWidth=".046" />
        </g>
        <path
          d="m.402 10.6c-.00909-5.74-.0165-10.4-.0165-10.4 0-.0104 8.49.13 8.5.141.00712.00795-1.85 4.56-4.12 10.1-2.28 5.56-4.18 10.2-4.24 10.4-.1.247-.103.0402-.119-10.2z"
          fill="#cf9"
          strokeWidth=".063"
        />
        <path
          d="m21.7 11c.0095-5.9.0172-10.7.0172-10.7 0-.0107-8.84.134-8.85.145-.0074.00817 1.93 4.69 4.3 10.4 2.37 5.71 4.36 10.5 4.42 10.6.105.254.107.0413.124-10.5z"
          fill="#cf9"
          strokeWidth=".0652"
        />
      </svg>
    </SvgIcon>
  );
};
